// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------

import { h } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import AttrFrom from '@/components/attrFrom/index.vue'

interface ModalAttrOptions {
  title?: string
  customClass?: string
  closeOnClickModal?: boolean
  showClose?: boolean
  showCancelButton?: boolean
  showConfirmButton?: boolean
}



export default function modalAttr(val: any, callback: () => void, options: ModalAttrOptions = {}) {
  return new Promise<void>((resolve, reject) => {
    ElMessageBox({
      title: options.title || '属性规格',
      // 对齐 EB .upload-form（min-width:1000px）；EP 默认 width:420px 会导致 span=8 输入框被压成竖条
      customClass: `${options.customClass || 'upload-form'} attr-spec-box`.trim(),
      customStyle: {
        width: '1000px',
        maxWidth: '96vw',
        minWidth: '720px',
      },
      closeOnClickModal: options.closeOnClickModal ?? false,
      showClose: options.showClose ?? true,
      message: h('div', { class: 'common-form-upload' }, [
        h(AttrFrom, {
          currentRow: val,
          onGetList: () => {
            callback()
          }
        })
      ]),
      showCancelButton: options.showCancelButton ?? false,
      showConfirmButton: options.showConfirmButton ?? false
    }).then(() => {
      resolve()
    }).catch(() => {
      reject()
      ElMessage({
        type: 'info',
        message: '已取消'
      })
    })
  })
}
